import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authenticate: handlers.authenticate,
    logout: handlers.logout,
    resendCode: handlers.resendCode,
    set2faUserId: handlers.set2faUserId,
  },
});

export const { actions } = auth;

export default auth.reducer;
